import Cookies from 'js-cookie';

let isGA4Initialized = false;

export const initializeGA4 = (consent) => {
  if (consent === 'accepted' && !isGA4Initialized) {
    window.gtag('consent', 'update', {
      'analytics_storage': 'granted'
    });
    window.gtag('config', 'G-Z9D7XE1TEJ');
    isGA4Initialized = true;
  } else {
    window.gtag('consent', 'update', {
      'analytics_storage': 'denied'
    });
  }
};

export const checkGAConsent = () => {
  return Cookies.get('ga_consent') === 'true';
}; 